<template>
  <modal
    name="participant-deleted-modal"
    :classes="['modal-window']"
    transition="scale"
    scrollable
    adaptive
    :click-to-close="false"
    :width="280"
    height="auto"
    @before-open="onModalBeforeOpen"
  >
    <div class="modal-container">
      <div class="modal__text mb30">
        {{ $t('dashboard.label.participantDeleted') }}
        <br />
        <span v-if="deletedWithPointsTransfer">
          {{ $t('dashboard.label.skinpointsTransferred') }}
        </span>
      </div>
      <div class="flex--center--center">
        <button class="rounded-button-gray" @click="onOkClick">
          {{ $t('dashboard.button.ok') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ParticipantDeletedModal',
  data() {
    return {
      deletedWithPointsTransfer: false
    };
  },
  methods: {
    onModalBeforeOpen({ params: { deletedWithPointsTransfer = false } }) {
      this.deletedWithPointsTransfer = deletedWithPointsTransfer;
    },
    onOkClick() {
      this.$emit('update-paticipant-list');
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide('participant-deleted-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/common/buttons';
@import '../../../../assets/scss/helpers/colors';

.modal {
  &-container {
    padding: 30px 20px;
  }

  &__text {
    font-size: 13px;
    font-weight: 300;
    line-height: 19px;
    color: $text-color;
    text-align: center;
  }
}
</style>
